const ENV = {
  dev: {
    base: "http://localhost:8080/api",
    ping: {
      client_id: "b635c1ce-1de9-443e-b7b7-10b71f767dc2",
      auth_url: "https://sso.connect.pingidentity.com/sso/as/authorization.oauth2",
      redirect_uri: "http://localhost:8000",
    },
  },
  uat: {
    base: "http://localhost:8000/api",
    ping: {
      client_id: "e409a9b8-89c9-40de-8c05-33528423e836",
      auth_url: "https://sso.connect.pingidentity.com/sso/as/authorization.oauth2",
      redirect_uri: "https://dev.frontier.app.taskus.com",
    },
  },
  prod: {
    base: "https://wday-snapshot.taskus.com/api",
    ping: {
      client_id: "ee381dd9-2214-4331-b365-356cc0a95a80",
      auth_url: "https://sso.connect.pingidentity.com/sso/as/authorization.oauth2",
      redirect_uri: "https://wday-snapshot.taskus.com",
    },
  },
};

export const getEnv = (env = "prod") => {
  let vars;
  if (env === "dev") {
    vars = ENV.dev;
  } else if (env === "uat") {
    vars = ENV.uat;
  } else {
    vars = ENV.prod;
  }
  return vars;
};
